import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/offices')({
    component: OfficesPage,
});

function OfficesPage() {
    return <Navigate to="/settings/notifications" replace={true} />;
}
